import { getI18n } from "@editor/ui-utils";
const de = {
  seoWhitelistApi: {
    createAlreadyExists: "Kann Domain nicht erstellen, da bereits eine Domain mit diesem Namen existiert",
    updateAlreadyExists: "Kann Domain nicht aktualisieren, da bereits eine Domain mit diesem Namen existiert",
    created: "Domain erstellt",
    updated: "Domain aktualisiert",
    notFound: "Domain nicht gefunden",
    requiredFields: "Sie können die Domain nicht speichern, da Pflichtinformationen fehlen"
  },
  seoWhitelistList: {
    newButton: "Neue Domain",
    name: "Nach URL suchen",
    deleteSeoWhitelist: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Seiten laden",
    headerLabel: "Link",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    headerChangedBy: "Zuletzt geändert von",
    dpEdit: "Domain Bearbeiten",
    dpView: "Domain Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createSeoWhitelist: "Domains erstellen",
    bannerMessage: "Die hier eingetragenen Domains erhalten Links mit follow-Attribut. Subdomains müssen separat in die Liste eingetragen werden, wenn sie ebenfalls follow-Links erhalten sollen. Bitte trage nur den Namen der Domain ein, ohne Protokoll- oder Pfadteile (example.com, sub.example.com)."
  },
  seoWhitelist: {
    seoWhitelistLabel: "Whitelist-Domain",
    backButton: "Zurück zur Domainliste",
    newSeoWhitelist: "Neue Domain",
    messageDeleteSeoWhitelist: "Sind Sie sicher, dass Sie den folgenden Domain aus der Follow-Whitelist entfernen möchten: ",
    messageDeleteSeoWhitelistTitle: "'Sind Sie sicher, dass Sie diese Seiten löschen möchten?",
    deleteSeoWhitelist: "Löschen",
    messageDeleted: "Domain gelöscht",
    errorOnDeleting: "Fehler beim Löschen der Domain",
    errorFailedLoadedSeoWhitelistWithId: "Fehler beim Abrufen der Domain",
    domainNameInvalid: "Ungültiger Domain-Name"
  },
  seoWhitelistEdit: {
    label: "Whitelist-Domain",
    backButton: "Domain bearbeiten",
    editSeoWhitelist: "Domain bearbeiten",
    messageSaved: "Domain gespeichert",
    messageUpdated: "Domain aktualisiert",
    deleteButton: "Domain löschen"
  }
};
const en = {
  seoWhitelistApi: {
    createAlreadyExists: "Can't create Domain because another Domain with this name already exists",
    updateAlreadyExists: "Can't update Domain because another Domain with this name already exists",
    created: "Domain created",
    updated: "Domain updated",
    notFound: "Domain not found",
    requiredFields: "You can't save the Domain because mandatory information is missing"
  },
  seoWhitelistList: {
    newButton: "New Domain",
    name: "Search by URL",
    deleteSeoWhitelist: "Yes, remove",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading Domains",
    headerLabel: "Link",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    headerChangedBy: "Last Change by",
    dpEdit: "Edit Domain",
    dpView: "View Domain",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createSeoWhitelist: "Create Domains",
    bannerMessage: "The domains of this list will receive links with a follow attribute. Subdomains have to be added separately to the list in case they should receive follow links as well. Please only enter the name of the domain, without protocol or path parts (example.com , sub.example.com)."
  },
  seoWhitelist: {
    seoWhitelistLabel: "SeoWhitelist",
    backButton: "Back to Domain list",
    newSeoWhitelist: "New Domain",
    messageDeleteSeoWhitelist: "Delete SeoWhitelist",
    messageDeleteSeoWhitelistTitle: "Are you sure you want to remove following domain  from the follow whitelist: ",
    deleteSeoWhitelist: "Remove domain",
    messageDeleted: "Domain Deleted",
    errorOnDeleting: "There was an error deleting the domain ",
    errorFailedLoadedSeoWhitelistWithId: "There was an error getting the domain",
    domainNameInvalid: "Invalid domain name"
  },
  seoWhitelistEdit: {
    label: "Whitelisted domain",
    backButton: "ack to Domains list",
    editSeoWhitelist: "Edit Domain",
    messageSaved: "New Domain saved",
    messageUpdated: "Domain updated",
    deleteButton: "Delete Domain"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/seo-whitelist",
    children: [
      {
        path: "",
        name: "seo_whitelist-list",
        component: () => import("./seo-whitelist-list.view-CPwbJoks.js"),
        meta: { requiredRight: "navigate_list_seo-whitelist" }
      },
      {
        path: "new",
        name: "seo_whitelist-new",
        component: () => import("./seo-whitelist-edit.view-oVQHrUi1.js"),
        props: () => ({ title: getI18n().t("seoWhitelist.newSeoWhitelist") }),
        meta: { requiredRight: ["navigate_seo-whitelist"] }
      },
      {
        path: ":id",
        name: "seo_whitelist-detail",
        component: () => import("./seo-whitelist-edit.view-oVQHrUi1.js"),
        props: (route) => ({
          title: getI18n().t("seoWhitelistEdit.editSeoWhitelist"),
          id: route.params.id,
          backRoute: "/seo-whitelist"
        }),
        meta: { requiredRight: ["navigate_seo-whitelist"] }
      }
    ]
  }
];
const seoWhitelistModule = {
  messages,
  routes
};
export {
  seoWhitelistModule
};
//# sourceMappingURL=index.es.js.map
